// extracted by mini-css-extract-plugin
export default {"root":"ZDPnD0Iv","title":"oOg8skW9","subtitle":"QQJPM85C"};